import React, {useRef, useState} from 'react';
import {Button, Col, Layout, Row} from "antd";
import {Content} from "antd/es/layout/layout";
import './ProDynamicTable.scss'

const TikIcon = () => <svg xmlns="http://www.w3.org/2000/svg" width="27" height="27" viewBox="0 0 27 27" fill="none">
    <g clip-path="url(#clip0_3047_1672)">
        <path
            d="M14.8496 1.34961H12.1496C6.18493 1.34961 1.34961 6.18493 1.34961 12.1496V14.8496C1.34961 20.8143 6.18493 25.6496 12.1496 25.6496H14.8496C20.8143 25.6496 25.6496 20.8143 25.6496 14.8496V12.1496C25.6496 6.18493 20.8143 1.34961 14.8496 1.34961Z"
            stroke="#936846" stroke-width="2.7"/>
        <path fill-rule="evenodd" clip-rule="evenodd"
              d="M11.4336 18.7777L10.4751 17.8192L7.14062 14.4847L9.04412 12.5812L11.4336 14.9707L17.2656 9.13867L19.1691 11.0422L12.3786 17.8327L11.4201 18.7912L11.4336 18.7777Z"
              fill="#936846"/>
    </g>
    <defs>
        <clipPath id="clip0_3047_1672">
            <rect width="27" height="27" fill="white"/>
        </clipPath>
    </defs>
</svg>
const ProDynamicTable = (props) => {
    const {ans1, ans2, ans3, ans4} = props
    const [openTour, setOpenTour] = useState(false);
    const steps = [
        {
            title: 'Step 1',
            description: 'This step highlights cell11 and cell12.',
            selectors: ['.cell11', '.cell12'],
            placement: 'bottom', // You can adjust the placement
        },
        {
            title: 'Step 2',
            description: 'This step highlights cell13.',
            selectors: ['.cell13'],
            placement: 'bottom',
        },
        // Add more steps as needed
    ]
    return (
        <>
            <Button type="primary" onClick={() => setOpenTour(true)}>
                Begin Tour
            </Button>
            <Row style={{
                width: '85vw',
                height: '8vh',
                margin: "auto",
                background: "white",
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-start",
                paddingTop: '1vw',
                paddingBottom: '1vw',
                paddingLeft: '8vw',
                paddingRight: '0'
            }}>
                <Col style={{width: '30vw', textAlign: 'left'}} className={'pro-dy-table-title'}>
                    Features
                </Col>
                <Col style={{width: '15vw'}} className={'pro-dy-table-title'}>
                    Standard
                </Col>
                <Col style={{width: '15vw'}} className={'pro-dy-table-title'}>
                    Advanced
                </Col>
                <Col style={{width: '15vw'}} className={'pro-dy-table-title'}>
                    Premium
                </Col>
            </Row>
            <Row style={{
                width: '85vw',
                height: '8vh',
                margin: "auto",
                background: "#F8F9FA",
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-start",
                paddingTop: '1vw',
                paddingBottom: '1vw',
                paddingLeft: '8vw',
                paddingRight: '0'
            }}>
                <Col style={{width: '30vw'}} className={'pro-dy-table-content-left cell11'}>
                    Number of Textura Pro Canvases Displayable
                </Col>
                <Col style={{width: '15vw'}} className={'pro-dy-table-content cell12'}>
                    Up to 2
                </Col>

                <Col style={{width: '15vw'}} className={'pro-dy-table-content cell13'}>
                    Unlimited
                </Col>
                <Col style={{width: '15vw'}} className={'pro-dy-table-content cell14'}>
                    Unlimited
                </Col>
            </Row>
            <Row style={{
                width: '85vw',
                height: '8vh',
                margin: "auto",
                background: "white",
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-start",
                paddingTop: '1vw',
                paddingBottom: '1vw',
                paddingLeft: '8vw',
                paddingRight: '0'
            }}>
                <Col style={{width: '30vw'}} className={'pro-dy-table-content-left'}>
                    Cloud storage for your media (photos, images, videos)
                </Col>
                <Col style={{width: '15vw'}} className={'pro-dy-table-content'}>
                    500MB
                </Col>
                <Col style={{width: '15vw'}} className={'pro-dy-table-content'}>
                    4GB
                </Col>
                <Col style={{width: '15vw'}} className={'pro-dy-table-content'}>
                    Unlimited
                </Col>
            </Row>
            <Row style={{
                width: '85vw',
                height: '8vh',
                margin: "auto",
                background: "#F8F9FA",
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-start",
                paddingTop: '1vw',
                paddingBottom: '1vw',
                paddingLeft: '8vw',
                paddingRight: '0'
            }}>
                <Col style={{width: '30vw'}} className={'pro-dy-table-content-left'}>
                    Access to Classic Creative Commons Artwork (CC0)
                </Col>
                <Col style={{width: '15vw'}} className={'pro-dy-table-content'}>
                    <TikIcon/>
                </Col>
                <Col style={{width: '15vw'}} className={'pro-dy-table-content'}>
                    <TikIcon/>
                </Col>
                <Col style={{width: '15vw'}} className={'pro-dy-table-content'}>
                    <TikIcon/>
                </Col>
            </Row>
            <Row style={{
                width: '85vw',
                height: '8vh',
                margin: "auto",
                background: "white",
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-start",
                paddingTop: '1vw',
                paddingBottom: '1vw',
                paddingLeft: '8vw',
                paddingRight: '0'
            }}>
                <Col style={{width: '30vw'}} className={'pro-dy-table-content-left'}>
                    Access to Advanced Royalty-free Classic Artwork (CC0)
                </Col>
                <Col style={{width: '15vw'}} className={'pro-dy-table-content'}>
                    -
                </Col>
                <Col style={{width: '15vw'}} className={'pro-dy-table-content'}>
                    <TikIcon/>
                </Col>
                <Col style={{width: '15vw'}} className={'pro-dy-table-content'}>
                    <TikIcon/>
                </Col>
            </Row>
            <Row style={{
                width: '85vw',
                height: '8vh',
                margin: "auto",
                background: "#F8F9FA",
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-start",
                paddingTop: '1vw',
                paddingBottom: '1vw',
                paddingLeft: '8vw',
                paddingRight: '0'
            }}>
                <Col style={{width: '30vw'}} className={'pro-dy-table-content-left'}>
                    Access to Premium Playlist with Rare Artwork
                </Col>
                <Col style={{width: '15vw'}} className={'pro-dy-table-content'}>
                    -
                </Col>
                <Col style={{width: '15vw'}} className={'pro-dy-table-content'}>
                    -
                </Col>
                <Col style={{width: '15vw'}} className={'pro-dy-table-content'}>
                    <TikIcon/>
                </Col>
            </Row>
            <Row style={{
                width: '85vw',
                height: '8vh',
                margin: "auto",
                background: "white",
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-start",
                paddingTop: '1vw',
                paddingBottom: '1vw',
                paddingLeft: '8vw',
                paddingRight: '0'
            }}>
                <Col style={{width: '30vw'}} className={'pro-dy-table-content-left'}>
                    Priced Artwork
                </Col>
                <Col style={{width: '15vw'}} className={'pro-dy-table-content'}>
                    Pay as priced
                </Col>
                <Col style={{width: '15vw'}} className={'pro-dy-table-content'}>
                    Unlimited
                </Col>
                <Col style={{width: '15vw'}} className={'pro-dy-table-content'}>
                    Unlimited
                </Col>
            </Row>
            <Row style={{
                width: '85vw',
                height: '8vh',
                margin: "auto",
                background: "#F8F9FA",
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-start",
                paddingTop: '1vw',
                paddingBottom: '1vw',
                paddingLeft: '8vw',
                paddingRight: '0'
            }}>
                <Col style={{width: '30vw'}} className={'pro-dy-table-content-left'}>
                    Platform Management Services
                </Col>
                <Col style={{width: '15vw'}} className={'pro-dy-table-content'}>
                    -
                </Col>
                <Col style={{width: '15vw'}} className={'pro-dy-table-content'}>
                    -
                </Col>
                <Col style={{width: '15vw'}} className={'pro-dy-table-content'}>
                    <TikIcon/>
                </Col>
            </Row>
            <Row style={{
                width: '85vw',
                height: '8vh',
                margin: "auto",
                background: "white",
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-start",
                paddingTop: '1vw',
                paddingBottom: '1vw',
                paddingLeft: '8vw',
                paddingRight: '0'
            }}>
                <Col style={{width: '30vw'}} className={'pro-dy-table-content-left'}>
                    Artwork Content Management with your own dedicated Art Curator
                </Col>
                <Col style={{width: '15vw'}} className={'pro-dy-table-content'}>
                    -
                </Col>
                <Col style={{width: '15vw'}} className={'pro-dy-table-content'}>
                    -
                </Col>
                <Col style={{width: '15vw'}} className={'pro-dy-table-content'}>
                    <TikIcon/>
                </Col>
            </Row>

            <Row style={{
                width: '85vw',
                height: '8vh',
                margin: "auto",
                background: "#F8F9FA",
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-start",
                paddingTop: '1vw',
                paddingBottom: '1vw',
                paddingLeft: '8vw',
                paddingRight: '0'
            }}>
                <Col style={{width: '30vw'}} className={'pro-dy-table-content-left'}>
                    Dedicated Technical Support Team (Telephone and Email Support)
                </Col>
                <Col style={{width: '15vw'}} className={'pro-dy-table-content'}>
                    <TikIcon/>
                </Col>
                <Col style={{width: '15vw'}} className={'pro-dy-table-content'}>
                    <TikIcon/>
                </Col>
                <Col style={{width: '15vw'}} className={'pro-dy-table-content'}>
                    <TikIcon/>
                </Col>
            </Row>
            <Row style={{
                width: '85vw',
                height: '8vh',
                margin: "auto",
                background: "white",
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-start",
                paddingTop: '1vw',
                paddingBottom: '1vw',
                paddingLeft: '8vw',
                paddingRight: '0'
            }}>
                <Col style={{width: '30vw'}} className={'pro-dy-table-content-left'}>
                    Dedicated Commercial Support Team (WhatsApp Business)
                </Col>
                <Col style={{width: '15vw'}} className={'pro-dy-table-content'}>
                    -
                </Col>
                <Col style={{width: '15vw'}} className={'pro-dy-table-content'}>
                    <TikIcon/>
                </Col>
                <Col style={{width: '15vw'}} className={'pro-dy-table-content'}>
                    <TikIcon/>
                </Col>
            </Row>
            <Row style={{
                width: '85vw',
                height: '24vh',
                margin: "auto",
                background: "white",
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-start",
                paddingTop: '1vw',
                paddingBottom: '1vw',
                paddingLeft: '8vw',
                paddingRight: '0',
                marginBottom: '4vh'
            }}>
                <Col style={{width: '30vw'}} className={'pro-dy-table-content-left'}>

                </Col>
                <Col style={{width: '15vw'}} className={'pro-dy-table-content'}>
                    <p className={'pro-dy-table-p1'}>Standard</p>
                    <p className={'pro-dy-table-p2'}>£0</p>
                    <p className={'pro-dy-table-p3'}>device / year</p>
                    <button className={'homeMainButton black-border-hover-white pro-dy-table-btn'}>GET STARTED</button>
                </Col>
                <Col style={{width: '15vw'}} className={'pro-dy-table-content'}>
                    <p className={'pro-dy-table-p1'}>Advanced</p>
                    <p className={'pro-dy-table-p2'}>£99</p>
                    <p className={'pro-dy-table-p3'}>device / year</p>
                    <button className={'homeMainButton black-border-hover-white pro-dy-table-btn'}>GET STARTED</button>
                </Col>
                <Col style={{width: '15vw'}} className={'pro-dy-table-content'}>
                    <p className={'pro-dy-table-p1'}>Premium</p>
                    <p className={'pro-dy-table-p2'}>£189</p>
                    <p className={'pro-dy-table-p3'}>device / year</p>
                    <button className={'homeMainButton black-border-hover-white pro-dy-table-btn'}>GET STARTED</button>
                </Col>
            </Row>
        </>
    )
}

export default ProDynamicTable;
